import SiteNavbar from "@/components/SiteNavbar";
import { SiLine } from "react-icons/si";
import { Phone } from "lucide-react";

const Index = () => {
  return (
    <div style={{ background: "#0D0D0D", minHeight: "100vh", fontFamily: "Rajdhani, sans-serif" }}>
      <SiteNavbar currentPage="/#/reviews" />

      {/* Hero */}
      <section
        style={{
          background: "linear-gradient(135deg, #0D0D0D 0%, #1a0a0a 100%)",
          paddingTop: "120px",
          paddingBottom: "60px",
          textAlign: "center",
          borderBottom: "1px solid rgba(232,33,42,0.2)",
        }}
      >
        <div className="container mx-auto px-4">
          <p
            style={{
              color: "#E8212A",
              fontSize: "13px",
              letterSpacing: "0.3em",
              textTransform: "uppercase",
              fontWeight: 700,
              marginBottom: "16px",
            }}
          >
            Customer Reviews
          </p>
          <h1
            style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: "clamp(36px, 7vw, 80px)",
              fontWeight: 700,
              color: "#fff",
              lineHeight: 1.05,
              marginBottom: "20px",
            }}
          >
            รีวิว &amp; <span style={{ color: "#E8212A" }}>ผลงาน</span>
          </h1>
          <p
            style={{
              fontFamily: "Sarabun, sans-serif",
              fontSize: "clamp(15px, 2.5vw, 20px)",
              color: "rgba(255,255,255,0.65)",
              maxWidth: "520px",
              margin: "0 auto",
              lineHeight: 1.7,
            }}
          >
            ดูรีวิวจากลูกค้าจริง ผลงานการติดตั้ง DWD Coilover และอุปกรณ์ Performance จาก ENZO Performante Store
          </p>
        </div>
      </section>

      {/* YouTube Video */}
      <section style={{ padding: "80px 0" }}>
        <div className="container mx-auto px-4">
          <div
            style={{
              maxWidth: "900px",
              margin: "0 auto",
            }}
          >
            <div
              style={{
                position: "relative",
                paddingBottom: "56.25%",
                height: 0,
                overflow: "hidden",
                borderRadius: "8px",
                border: "1px solid rgba(232,33,42,0.3)",
                boxShadow: "0 8px 60px rgba(0,0,0,0.6)",
              }}
            >
              <iframe
                src="https://www.youtube.com/embed/ywf60lbduug?si=EStjZH3RDkIYIfqh"
                title="ENZO Performante Store Review"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
              />
            </div>

            {/* Video caption */}
            <div
              style={{
                marginTop: "20px",
                padding: "20px",
                background: "#161616",
                border: "1px solid rgba(255,255,255,0.07)",
                borderRadius: "6px",
              }}
            >
              <p
                style={{
                  fontFamily: "Rajdhani, sans-serif",
                  fontSize: "11px",
                  color: "#E8212A",
                  letterSpacing: "0.2em",
                  textTransform: "uppercase",
                  fontWeight: 700,
                  marginBottom: "6px",
                }}
              >
                Featured Review
              </p>
              <h3
                style={{
                  fontFamily: "Rajdhani, sans-serif",
                  fontSize: "22px",
                  fontWeight: 700,
                  color: "#fff",
                  marginBottom: "8px",
                }}
              >
                ENZO Performante Store — รีวิวผลงานจากลูกค้า
              </h3>
              <p
                style={{
                  fontFamily: "Sarabun, sans-serif",
                  fontSize: "14px",
                  color: "rgba(255,255,255,0.55)",
                  lineHeight: 1.7,
                }}
              >
                ชมรีวิวและผลงานการติดตั้ง DWD Coilover ระบบเบรก MOTVE และอุปกรณ์ Performance จากลูกค้าจริง
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Booking CTA */}
      <section
        style={{
          background: "#111",
          borderTop: "1px solid rgba(232,33,42,0.2)",
          padding: "80px 0",
          textAlign: "center",
        }}
      >
        <div className="container mx-auto px-4">
          <p
            style={{
              color: "#E8212A",
              fontSize: "13px",
              letterSpacing: "0.3em",
              textTransform: "uppercase",
              fontWeight: 700,
              marginBottom: "16px",
            }}
          >
            จองคิวติดตั้ง
          </p>
          <h2
            style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: "clamp(28px, 5vw, 52px)",
              fontWeight: 700,
              color: "#fff",
              marginBottom: "16px",
            }}
          >
            พร้อมอัพเกรดรถของคุณ<span style={{ color: "#E8212A" }}>แล้วหรือยัง?</span>
          </h2>
          <p
            style={{
              fontFamily: "Sarabun, sans-serif",
              fontSize: "16px",
              color: "rgba(255,255,255,0.55)",
              marginBottom: "40px",
            }}
          >
            ติดต่อเพื่อจองคิวล่วงหน้า หรือสอบถามข้อมูลเพิ่มเติมได้เลย
          </p>

          <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
            <a
              href="https://lin.ee/usuFQKq"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                padding: "14px 32px",
                background: "#06C755",
                color: "#fff",
                textDecoration: "none",
                fontFamily: "Rajdhani, sans-serif",
                fontWeight: 700,
                fontSize: "16px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                borderRadius: "4px",
              }}
            >
              <SiLine size={20} /> จองคิวผ่าน LINE
            </a>
            <a
              href="tel:0869978800"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                padding: "14px 32px",
                background: "transparent",
                border: "2px solid rgba(232,33,42,0.5)",
                color: "#fff",
                textDecoration: "none",
                fontFamily: "Rajdhani, sans-serif",
                fontWeight: 700,
                fontSize: "16px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                borderRadius: "4px",
              }}
            >
              <Phone size={20} /> 086-997-8800
            </a>
          </div>
        </div>
      </section>

      {/* TikTok Video */}
      <section style={{ padding: "0 0 80px" }}>
        <div className="container mx-auto px-4">
          <div style={{ maxWidth: "900px", margin: "0 auto" }}>
            <div style={{ marginBottom: "28px", textAlign: "center" }}>
              <p style={{ color: "#aaa", fontFamily: "Rajdhani, sans-serif", fontSize: "11px", letterSpacing: "0.2em", textTransform: "uppercase", marginBottom: "8px" }}>TIKTOK REVIEW</p>
              <h2 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "clamp(22px,3vw,32px)", fontWeight: 800, textTransform: "uppercase" }}>
                DWD Coilover — <span style={{ color: "#E8212A" }}>รถน้ำมัน &amp; EV</span>
              </h2>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <blockquote
                className="tiktok-embed"
                cite="https://www.tiktok.com/@iracealot/video/7614466622832626952"
                data-video-id="7614466622832626952"
                style={{ maxWidth: "605px", minWidth: "325px", width: "100%", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "8px", overflow: "hidden" } as React.CSSProperties}
              >
                <section>
                  <a target="_blank" title="@iracealot" href="https://www.tiktok.com/@iracealot?refer=embed">@iracealot</a>
                  {" "}เพราะความสบายของคนในรถคือเรื่องสำคัญ 🤍 DWD Coilover ทั้งรถน้ำมันและรถไฟฟ้า
                </section>
              </blockquote>
            </div>
          </div>
        </div>
        <script async src="https://www.tiktok.com/embed.js"></script>
      </section>
    </div>
  );
};

export default Index;
